<template>
  <div class="box">
    <div class="title">
      <img src="@/assets/images/success-icon.png" v-if="!jetlympic" />
      <img src="@/assets/images/success-icon2.png" v-else />
      <div class="h1">
        {{title1}}
      </div>
      <div class="match-info">
        <img :src="imageView(match.icon)" style="margin-bottom: 8px;" v-if="match.icon" />
        {{ match.unionMatchName }}
      </div>
      <div v-if="match.signupInstructions" class="signup-instructions overflow-text-tow">{{ match.signupInstructions }}</div>
    </div>
    <div class="team-box">
      <div class="team-title" @click="goPersonInfo">
        <div class="team-info">
          <img :src="imageView(team.badge)" v-if="team.badge" />
          {{ team.name }}
        </div>
        <div class="status" style="display: flex; align-items: center;">
          {{ $t(`match.personSuccess.text_2`) }}
          <van-icon name="arrow" class="arrow" size="18px" />
        </div>
      </div>
      <div class="team">
         <div class="left">
          报名状态
        </div>
        <div class="status">
          <span v-if="team.isSubmit === 0">未提交</span>
          <span v-else-if="team.auditStatus === 0 || team.auditStatus === 1">待确认</span>
          <span v-else-if="team.auditStatus === 3">已锁定</span>
          <span v-else-if="team.auditStatus === 2">已确认</span>
          <span v-else-if="team.auditStatus === -1">已退回</span>
        </div>
      </div>
    </div>
    <div class="banner" @click="goInsurance" v-if="!jetlympic">
      <div class="banner-left">
        赛事保险
      </div>
      <div class="banner-right">
        <img src="@/assets/images/insurance-icon.png" />
        踢球有保障·极速赔付·最高20万
         <van-icon name="arrow" class="arrow" size="18px" />
      </div>
    </div>
    <div class="list">
      <div class="list-item" @click="goMatchHome">
        <div class="left">
          <div class="name">{{ $t(`match.personSuccess.text_3`) }}</div>
          <div class="text">了解最新比赛赛程·积分·公告</div>
        </div>
        <div class="right" :style="{'background-color':jetlympic? '#00A7FF': '#509DEA' }">{{ $t(`match.personSuccess.text_4`) }}</div>
      </div>
      <div class="list-item" v-if="!jetlympic">
        <div class="left">
          <div class="name">专属球队空间 <img src="@/assets/images/vip-banner.png" class="team-space-icon"> </div>
          <div class="text">球队出勤/相册/数据管理</div>
        </div>
        <div class="right" :style="{'background-color':jetlympic? '#00A7FF': '#509DEA' }">前往</div>
      </div>
    </div>
     <div class="footer"  v-if="team.isSubmit === 0 || team.auditStatus === -1">
      <div class="left">
      </div>
      <div class="right">
        <div class="btn" @click="updateBMMatchTeam()">提交</div>
      </div>
    </div>
    <ShareLayer :shareShow="shareShow" @close="shareShow = false"></ShareLayer>
  </div>
</template>

<script>
import { getBMUnionMatch,getBMMatchTeamSignup,checkBMMatchBeforeSubmit,submitBMMatchTeam,bangsaishiCreateTeamSignupOrder } from '@/api/match'
import { QNImageUtil, isWeChatMiniApp } from "@/utils";
import { getToken } from '@/libs/cookie-storage'

import Vue from 'vue';
import { Toast,Dialog } from 'vant';
import ShareLayer from "@/components/ShareLayer"
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'
Vue.use(Dialog).use(Toast)
export default {
  components: { ShareLayer },
  data() {
    return {
      teamId: '',
      unionMatchId: '',
      matchId: '',
      match: {},
      team: {},
      players: [],
      type: '',
      shareShow: false,
      title1: this.$t(`match.personSuccess.text_1`),
      jetlympic: false
    };
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.teamId = this.$route.query.teamId
    this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.type = this.$route.query.type
    if (this.type === 'create') {
      this.title1 = this.$t(`match.personSuccess.text_1`)
    } else { 
      this.title1 = this.$t(`match.personSuccess.text_update_1`)
    }
    // this.getBMUnionMatch()
    this.getBMMatchTeamSignup()
  },
  methods: {
    updateBMMatchTeam() {
      if (this.match.isOpenCharge === 1 && (this.match.feeMethod === 2 || this.match.feeMethod === 3) && this.match.orderStatus !== 1 && this.match.orderStatus !== 2) {
        const params = {
          teamId: this.teamId,
          matchId:this.matchId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId:this.matchId,
                teamId: this.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.matchId}&teamId=${this.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: this.teamId,
          matchId:this.matchId
        }).then(res => {
          if (res) {
            const params = {
              teamId: this.teamId,
              matchId:this.matchId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Toast('提交成功')
                this.$router.back()
              }
            })
          }
        })
      }
    },
    goInsurance() {
      const passport = getToken()
      window.location.href = 'https://cpsh5.xiebao18.com/m/czh1007574/media-15005.html?passport=' + passport
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getBMUnionMatch() {
      getBMUnionMatch({
        unionMatchId: this.unionMatchId
      }).then(res => {
        console.log(res)
        const { data } = res
        this.match = data.match 
      })
    },
    getBMMatchTeamSignup() {
      getBMMatchTeamSignup({
        matchId: this.matchId,
        teamId: this.teamId
      }).then(res => {
        const { data } = res
        this.match = data.match
        this.team = data.team
        this.players = data.players
      })
    },
    goPersonInfo() {
      this.$router.push({
        path: '/entry-page/entry-info-person',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          teamId: this.teamId
        }
      })
    },
    goMatchHome() {
      this.$router.push({
        path: '/union-match/match-overall',
        query: {
          unionMatchId: this.unionMatchId
        }
      })
    },
    goTeamPlayers() {
      this.$router.push({
        path: '/entry-page/entry-info',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          teamId: this.teamId
        }
      })
    },
    goEntryList() {
      this.$router.push({
        path: '/entry-page/entry-list',
        query: {
          unionMatchId: this.unionMatchId,
          role: 0
        }
      })
    },
    async weChatShare() {
      // 先判断是否在微信环境
      if (!AppType.isInWeChat()) {
        Toast.fail('请在微信环境下打开')
        return
      }
      
      // 判断是否为微信小程序环境
      const isMiniApp = await isWeChatMiniApp()
      
      if (isMiniApp) {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/share/index?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}`
        })
      } else {
        // 微信浏览器环境
        this.shareShow = true
        const shareObj = {
          title: this.team.name + '邀请您加入',
          abstract: this.team.name + '邀请您参加' + this.match.unionMatchName + '/' + this.match.group + '的比赛',
          link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.matchId + '&teamId=' + this.teamId,
          image: this.match.icon ? QNImageUtil.imageView(this.match.icon) : ''
        }
        this.wxShare(shareObj)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box{
  min-height: 100vh;
  background-color: #F6F6F6;
  .title{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 180px;
    box-sizing: border-box;
    img{
      width: 27px;
      height: 27px;
      margin-bottom: 18px;
    }
    .h1{
      font-size: 20px;
      font-weight: 500;
      color: #3D3D3D;
    }
    .match-info{
      display: flex;
      font-size: 12px;
      color: #73767A;
      margin-top: 10px;
      font-weight: 500;
      img{
        width: 15px;
        height: 15px;
        margin-right: 5px;
        border-radius: 50%;
      }
    }
    .signup-instructions{
      width: 280px;
      text-align: center;
      font-size: 12px;
      color: #73767A;
    }
  }
  .team-box{
    background-color: #fff;
    .team-title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      font-size: 16px;
      color: #1D2129;
      border-bottom: 1px solid #F6F6F6;
      .team-info{
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #73767A;
        img{
          width: 24px;
          height: 24px;
          border: 0.75px solid #EEEEEE;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .wx{
        width: 106px;
        height: 25px;
        border-radius: 89px;
        // background: #11B93D;
        border: 1px solid #11B93D;
        font-size: 12px;
        color: #606266;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 16px;
          height: 12.76px;
          margin-right: 3px;
        }
      }
      .wx2{
        width: 91px;
        border: 1px solid #337ECC;
      }
    }
    .team{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      height: 58px;
      box-sizing: border-box;
      .left{
        font-size: 15px;
        font-weight: 500;
        color: #1D2129;
      }
      .right{
        display: flex;
        align-items: center;
        .number{
          font-size: 14px;
          font-weight: 500;
          color: #73767A;
          margin-right: 8px;
          span{
            color: #DC352B;
          }
        }
        .arrow{
          color: #73767A;
        }
      }
    }
  }
  .status{
    font-size: 13px;
    color: #73767A;
    font-weight: 500;
    color: #909399;
    margin-right: 4px;
  }
  .banner{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 57px;
    background-color: #fff;
    padding: 0 16px;
    border-top: 1px solid #F6F6F6;
    img{
      width: 21px;
      height: 21px;
      margin-right: 5px;
    }
    .banner-left{
      font-size: 15px;
      font-weight: 500;
      color: #1D2129;
      display: flex;
      align-items: center;
    }
    .banner-right{
      font-size: 13px;
      color: #F78C27;
      margin-right: 4px;
      display: flex;
      align-items: center;
      .arrow{
        color: #73767A;
        margin-left: 4px;
      }
    }
  }
  .list{
    margin-top: 10px;
    background-color: #fff;
    padding: 0 16px;
    .list-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0;
      &:not(:last-child){
        border-bottom: 1px solid #D8D8D8;
      }
      .left{
        .name{
          font-size: 15px;
          color: #1D2129;
          font-weight: 500;
          display: flex;
          align-items: center;
          img{
            margin-left: 5px;
          }
        }
        .text{
         font-size: 11px;
          color: #A3A6AC;
          margin-top: 5px;
        }
      }
      .right{
        width: 52px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border-radius: 55px;
        background: #4AA2F7;
        font-size: 12px;
        color: #fff;
      }
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
    background-color: #FFFFFF;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px 34px 12px;
    .right{
      .btn{
        width: 117px;
        height: 45px;
        border-radius: 69px;
        background: #509DEA;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 45px;
      }
    }
  }
}
</style>
